import { Select } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { Loader } from "../../Common/Components";

export const GlobalStyles = createGlobalStyle<{ $loading?: boolean }>`
  .select-dropdown-custom {
    padding: 0;
  }
`;

export const StyledSelect = styled(Select)<{ $loading?: boolean }>`
  & input:disabled {
    opacity: 0;
  }

  ${({ $loading }) =>
    $loading &&
    `
    cursor: progress;
    &&& .ant-select-selection-search-input {
      cursor: progress;
    }
  `}
`;
StyledSelect.displayName = "StyledSelect";

export const StyledOptionsWrapper = styled.div<{ $loading?: boolean }>`
  padding: 4px;
`;
StyledOptionsWrapper.displayName = "StyledOptionsWrapper";

export const StyledDimBackground = styled.div`
  cursor: progress;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
StyledDimBackground.displayName = "StyledDimBackground";

export const StyledLoader = styled(Loader)`
  position: absolute;
  z-index: 2;
  top: 50%;
  translate: 0 -50%;
  cursor: progress;
`;
StyledLoader.displayName = "StyledLoader";
